<template>
  <div class="q-pa-md">
    <div class="row col-12 q-mt-xl q-ml-md">
      <p class="text-h6 self-end text-brand-5 text-weight-bold">
        Selecione as ferramentas que deseja transferir:
      </p>
    </div>
    <q-table
      table-header-class="bg-accent text-width-bold"
      :filter="filter"
      :rows="rows"
      :columns="columns"
      :loading="disable"
      v-model:pagination="pagination"
      dense
      row-key="name"
      class="tabela-tamanho-fixo"
      hide-pagination
      @request="handleRequest"
    >
      <template v-slot:top-right>
        <q-input
          borderless
          dense
          debounce="300"
          v-model="filter"
          placeholder="Search"
        >
          <template v-slot:append>
            <q-icon name="search" />
          </template>
        </q-input>
      </template>
      <template #body-cell-uuid="props">
        <q-td>
          <q-btn
            size="sm"
            color="primary"
            icon="add_circle_outline"
            label="Selecionar"
            no-caps
            :disabled="
              escolhidas.find((e) => {
                return e.uuid == props.row.uuid;
              })
            "
            @click="emitir(props.row.uuid)"
          />
        </q-td>
      </template>
      <template #body-cell-patrimonio="props">
        <q-td>
          {{ props.row.patrimonio }}
        </q-td>
      </template>
      <template #body-cell-codigo="props">
        <q-td>
          {{ props.row.nome }}
        </q-td>
      </template>
      <template #body-cell-descricao="props">
        <q-td>
          {{ props.row.descricao }}
        </q-td>
      </template>
      <template #body-cell-status="props">
        <q-td>
          <div class="row align">
            <span
              v-if="props.row.status == 'disponivel'"
              class="circle q-mr-sm bg-light-green-4"
            ></span>
            <div
              v-if="props.row.status == 'disponivel'"
              style="width: fit-content"
              class="text-light-green-4 text-bold"
            >
              {{ props.row.status }}
            </div>
          </div>
        </q-td>
      </template>
    </q-table>
    <div class="row justify-start q-mt-md">
      <q-pagination
        :disable="disable"
        v-model="pagination.page"
        color="brand-5"
        active-color="secondary"
        active-text-color="white"
        :max="pagesNumber"
        :max-pages="5"
        :boundary-numbers="false"
        :direction-links="true"
        size="sm"
      />
    </div>
  </div>
</template>

<script>
const columns = [
  {
    name: "uuid",
    label: "Ferramentas Selecionadas",
    field: "uuid",
    align: "left",
  },
  {
    name: "patrimonio",
    label: "Patrimonio",
    field: "patrimonio",
    align: "left",
  },
  {
    name: "codigo",
    label: "Código",
    field: "nome",
    align: "left",
  },
  {
    name: "descricao",
    label: "Descrição",
    field: "descricao",
    align: "left",
  },
  {
    name: "status",
    label: "Status",
    field: "status",
    align: "left",
  },
];

import { ref, onMounted, watch, computed } from "vue";
import { useStore } from "vuex";

export default {
  props: ["escolhidas", "unidadeId"],
  emits: ["selecionados"],
  setup(props, { emit }) {
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 10,
      rowsNumber: 15,
    });
    const store = useStore();
    const ferramentasSelecionada = ref([]);
    const rows = ref([]);
    let filter = ref("");
    const disable = ref(true);
    const desabilitar = ref([]);

    const getFerramentas = async (page = 0, rowsPerPage = 15) => {
      let response = await store.dispatch(
        "fer/listarFerramentasTransferencia",
        {
          status: "disponivel",
          per_page: rowsPerPage,
          page,
          nome: filter.value,
          unidadeId: props.unidadeId,
        }
      );

      rows.value = response.data.result.data;

      pagination.value.rowsPerPage = response.data.result.per_page;
      pagination.value.rowsNumber = response.data.result.total;
      //pagination.value.page = response.data.result.current_page;

      disable.value = false;
    };

    const handleRequest = async () => {
      getFerramentas(pagination.value.page, pagination.value.rowsPerPage);
    };

    onMounted(getFerramentas);

    watch(
      () => pagination.value.page,
      () => {
        disable.value = true;
        handleRequest();
      }
    );

    watch(
      () => filter.value,
      () => {
        handleRequest();
      }
    );

    watch(
      () => store.state.org.unidadeData.id,
      () => {
        getFerramentas();
      }
    );

    const emitir = async (ferramenta) => {
      emit("selecionados", ferramenta);
    };

    return {
      filter,
      columns,
      rows,
      ferramentasSelecionada,
      getFerramentas,
      pagination,
      emitir,
      handleRequest,
      disable,
      desabilitar,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
    };
  },
};
</script>
<style scoped>
tbody tr td {
  white-space: pre-wrap;
}
.circle {
  width: 12px;
  height: 12px;

  border-radius: 50%;
}

.align {
  align-items: center;
}
</style>
